import axios from 'axios';

// Messenger API client for team chat backend
// Uses the same backend server as users API (port 3001)
// Use relative URL in production (proxied through Nginx), localhost in development
const getApiBaseUrl = () => {
  if (process.env.REACT_APP_USERS_API_URL) {
    return process.env.REACT_APP_USERS_API_URL;
  }
  // In production, use relative URL (proxied through Nginx)
  if (window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
    return ''; // Relative URL - will use current domain
  }
  // In development, use localhost
  return 'http://localhost:3001';
};

const API_BASE_URL = getApiBaseUrl();

const messengerApi = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  timeout: 10000 // 10 second timeout
});

// Request interceptor to add user_id to requests
messengerApi.interceptors.request.use(
  async (config) => {
    // Get user_id from localStorage or context
    // For now, we'll add it in the component, but this could be enhanced
    const fullUrl = `${config.baseURL}${config.url}`;
    console.log(`[Messenger API] ${config.method.toUpperCase()} ${fullUrl}`);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
messengerApi.interceptors.response.use(
  (response) => {
    // Backend returns { success, data, message }
    return response.data;
  },
  (error) => {
    // Handle network errors
    if (error.code === 'ECONNREFUSED' || error.message === 'Network Error') {
      const errorMessage = `Cannot connect to messenger server at ${API_BASE_URL}. Make sure the server is running.`;
      console.error('[Messenger API] Connection Error:', errorMessage);
      return Promise.reject(new Error(errorMessage));
    }
    
    // Handle timeout errors
    if (error.code === 'ECONNABORTED') {
      const errorMessage = `Request to ${API_BASE_URL} timed out.`;
      console.error('[Messenger API] Timeout Error:', errorMessage);
      return Promise.reject(new Error(errorMessage));
    }
    
    // Handle other errors
    const errorMessage = error.response?.data?.message || error.message || 'An error occurred';
    console.error('[Messenger API] Error:', errorMessage, error.response?.data);
    return Promise.reject(new Error(errorMessage));
  }
);

export default messengerApi;

